import React from "react";
import { Form, Button, Modal, Divider, Input } from "antd";
import {
  renderDate,
  renderInput,
  renderSelect,
  renderTextField,
} from "../../../component/form/form";

import { connect } from "react-redux";
import { getRoles } from "../../../actions/role";
import { updateUser, getUsersById } from "../../../actions/user";
import { useEffect, useState } from "react";

const tailLayout = {
  wrapperCol: { offset: 4, span: 16 },
};

const gender = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
];
const status = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

const EditModalForm = ({
  visible,
  setVisible,
  user_id,
  getRoles,
  getUsersById,
  updateUser,
  refresh,
}) => {
  const [data, setData] = useState(null);
  const [roles, setRoles] = useState(null);
  const [prevDate, setPrevDate] = useState("");
  const [form] = Form.useForm();

  useEffect(async () => {
    const res = await getRoles();
    setRoles(res);
    if (res) {
      const result = await getUsersById(user_id);
      setPrevDate(result?.personal_info?.date_of_birth);
      setData(result);
      form.setFieldsValue({
        name: result?.name,
        authenticated: result?.authenticated,
        email: result?.email,
        mobile_number: result?.mobile_number,
        user_id: result?.user_id,
        //date_of_birth : ,
        emergency_number: result?.personal_info?.emergency_number,
        gender: result?.personal_info?.gender,
        permanent_address: result?.personal_info?.permanent_address,
        present_address: result?.personal_info?.present_address,
        role: result?.roles?.role_id,
      });
    }
  }, []);

  const createRoles = (label, value) => {
    return { label, value };
  };
  const onFinish = async (values) => {
    const code = await updateUser(values);
    if (code === 201) {
      refresh();
      setVisible();
    }
  };

  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
  };
  let option = [];
  option = roles
    ? roles.map((item) => createRoles(item.name, item.role_id))
    : null;

  return (
    <Modal
      title="Update User Informartion"
      centered
      visible={visible}
      onOk={() => setVisible(false)}
      onCancel={() => setVisible(false)}
      width={1000}
    >
      {data ? (
        <Form
          name="basic"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ alignSelf: "center" }}
          requiredMark={false}
          form={form}
        >
          <Form.Item label="User ID" hidden={true} name="user_id">
          {/* <Input size="large" type="hidden"  /> */}
          </Form.Item>
          {/* {renderInput('user_id', 'User ID', [
                    { required: true, message: 'This field is required!' },
                  ])
                } */}
          {renderInput("name", "Full Name", [
            { required: true, message: "This field is required!" },
          ])}
          {renderInput("email", "Email", [
            { required: true, message: "This field is required!" },
          ])}
          {renderInput("mobile_number", "Mobile", [
            { required: true, message: "This field is required!" },
            { pattern: /^(01)[0-9][0-9]{8}$/, message: "Please valid number!" },
          ])}
          {renderSelect(
            "authenticated",
            "Status",
            [{ required: true }],
            "Select a option",
            status,
            "none"
          )}
          {roles
            ? renderSelect(
                "role",
                "Role",
                [{ required: true }],
                "Select a option",
                option,
                "none"
              )
            : null}
          <Divider orientation="center">Personal Information</Divider>

          {renderDate(
            "date_of_birth",
            "Date of Birth",
            [{ required: true, message: "Please input your birth date" }],
            prevDate
          )}
          {renderSelect(
            "gender",
            "Gender",
            [{ required: true }],
            "Select Your Gender",
            gender,
            "none"
          )}
          {renderTextField("permanent_address", "Permanent Address", [
            { required: true, message: "This field is required!" },
          ])}
          {renderTextField("present_address", "Present Address", [
            { required: true, message: "This field is required!" },
          ])}

          {renderInput("emergency_number", "Emergency Number", [
            { required: true, message: "This field is required!" },
            {
              pattern: /^(01)[0-9][0-9]{8}$/,
              message: "Please valid phone number!",
            },
          ])}
          {renderTextField("remark", "Remark", [
            { required: true, message: "This field is required!" },
          ])}

          <Form.Item {...tailLayout}>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      ) : null}
    </Modal>
  );
};

export default connect(null, { getRoles, updateUser, getUsersById })(
  EditModalForm
);
